import { render, staticRenderFns } from "./NoAccess.vue?vue&type=template&id=d952f16a&scoped=true"
var script = {}
import style0 from "./NoAccess.vue?vue&type=style&index=0&id=d952f16a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d952f16a",
  null
  
)

export default component.exports